"use client";

import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import MemeDropTraits from "@/components/memes/drops/MemeDropTraits";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
import { getRankHoverBorderClass } from "@/components/waves/drops/dropRankStyles";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { convertApiDropToExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";
import WaveWinnersDropHeaderAuthorPfp from "./header/WaveWinnersDropHeaderAuthorPfp";
import { WaveWinnerIdentity } from "../identity/WaveWinnerIdentity";
interface MemesWaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
const getRankHoverClass = (place: number | null): string => {
  return getRankHoverBorderClass(place);
};
export const MemesWaveWinnersDrop: React.FC<MemesWaveWinnersDropProps> = t0 => {
  const $ = _c(149);
  const {
    winner,
    wave,
    onDropClick
  } = t0;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  const title = winner.drop.metadata.find(_temp)?.data_value ?? "Artwork Title";
  const description = winner.drop.metadata.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
  let t2;
  if ($[2] !== winner.drop.parts) {
    t2 = winner.drop.parts.at(0)?.media.at(0);
    $[2] = winner.drop.parts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const artworkMedia = t2;
  const rating = winner.drop.rating || 0;
  const ratersCount = winner.drop.raters_count;
  let creditType;
  let extendedDrop;
  let hasUserVoted;
  let isUserVoteNegative;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let userVote;
  let userVoteClass;
  if ($[4] !== artworkMedia || $[5] !== description || $[6] !== hasTouchScreen || $[7] !== onDropClick || $[8] !== rating || $[9] !== title || $[10] !== touchHandlers || $[11] !== wave.voting.credit_type || $[12] !== winner) {
    const topVoters = winner.drop.top_raters.slice(0, 3);
    creditType = WAVE_VOTING_LABELS[wave.voting.credit_type];
    hasUserVoted = winner.drop.context_profile_context?.rating !== undefined && winner.drop.context_profile_context.rating !== 0;
    userVote = winner.drop.context_profile_context?.rating ?? 0;
    isUserVoteNegative = userVote < 0;
    const totalVoteClass = rating < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
    userVoteClass = isUserVoteNegative ? "tw-text-rose-400" : "tw-text-iron-50";
    let t19;
    if ($[35] !== winner.drop) {
      t19 = convertApiDropToExtendedDrop(winner.drop);
      $[35] = winner.drop;
      $[36] = t19;
    } else {
      t19 = $[36];
    }
    extendedDrop = t19;
    if ($[37] !== extendedDrop || $[38] !== onDropClick) {
      t17 = () => onDropClick(extendedDrop);
      $[37] = extendedDrop;
      $[38] = onDropClick;
      $[39] = t17;
    } else {
      t17 = $[39];
    }
    t18 = "touch-select-none tw-w-full tw-cursor-pointer tw-rounded-xl tw-transition-all tw-duration-300 tw-ease-out";
    let t20;
    if ($[40] !== winner.place) {
      t20 = getRankHoverClass(winner.place);
      $[40] = winner.place;
      $[41] = t20;
    } else {
      t20 = $[41];
    }
    t16 = `tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 tw-transition-all tw-duration-200 tw-ease-out ${t20}`;
    t10 = "tw-flex tw-flex-col";
    t11 = touchHandlers;
    let t21;
    if ($[42] !== winner) {
      t21 = <WaveWinnersDropHeaderAuthorPfp winner={winner} size="sm" />;
      $[42] = winner;
      $[43] = t21;
    } else {
      t21 = $[43];
    }
    let t22;
    if ($[44] !== winner.drop.author.handle || $[45] !== winner.drop.author.id || $[46] !== winner.drop.author.primary_address) {
      t22 = winner.drop.author.handle ? <UserProfileTooltipWrapper user={winner.drop.author.handle}><Link href={`/${winner.drop.author.handle}`} onClick={_temp3} scroll={false} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{winner.drop.author.handle}</span></Link></UserProfileTooltipWrapper> : <Link href={`/${winner.drop.author.handle ?? winner.drop.author.primary_address}`} onClick={_temp4} scroll={false} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{winner.drop.author.handle ?? winner.drop.author.id}</span></Link>;
      $[44] = winner.drop.author.handle;
      $[45] = winner.drop.author.id;
      $[46] = winner.drop.author.primary_address;
      $[47] = t22;
    } else {
      t22 = $[47];
    }
    let t23;
    if ($[48] !== winner.drop.author.level) {
      t23 = <UserCICAndLevel level={winner.drop.author.level} size={UserCICAndLevelSize.SMALL} />;
      $[48] = winner.drop.author.level;
      $[49] = t23;
    } else {
      t23 = $[49];
    }
    const t24 = `memes-winner-author-badges-${winner.drop.id}`;
    let t25;
    if ($[50] !== t24 || $[51] !== winner.drop.author) {
      t25 = <DropAuthorBadges profile={winner.drop.author} tooltipIdPrefix={t24} />;
      $[50] = t24;
      $[51] = winner.drop.author;
      $[52] = t25;
    } else {
      t25 = $[52];
    }
    let t26;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = <span className="tw-text-sm tw-text-iron-500">•</span>;
      $[53] = t26;
    } else {
      t26 = $[53];
    }
    let t27;
    if ($[54] !== winner.drop.created_at) {
      t27 = <WaveDropTime timestamp={winner.drop.created_at} />;
      $[54] = winner.drop.created_at;
      $[55] = t27;
    } else {
      t27 = $[55];
    }
    let t28;
    if ($[56] !== t22 || $[57] !== t23 || $[58] !== t25 || $[59] !== t27) {
      t28 = <div className="tw-flex tw-items-center"><div className="-tw-mt-0.5 tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1">{t22}{t23}{t25}{t26}{t27}</div></div>;
      $[56] = t22;
      $[57] = t23;
      $[58] = t25;
      $[59] = t27;
      $[60] = t28;
    } else {
      t28 = $[60];
    }
    let t29;
    if ($[61] !== t21 || $[62] !== t28) {
      t29 = <div className="tw-flex tw-gap-x-2">{t21}{t28}</div>;
      $[61] = t21;
      $[62] = t28;
      $[63] = t29;
    } else {
      t29 = $[63];
    }
    let t30;
    if ($[64] !== extendedDrop || $[65] !== hasTouchScreen) {
      t30 = !hasTouchScreen && <div className="tw-flex tw-flex-shrink-0 tw-items-center"><div className="tw-h-8"><WaveDropActionsOpen drop={extendedDrop} /></div></div>;
      $[64] = extendedDrop;
      $[65] = hasTouchScreen;
      $[66] = t30;
    } else {
      t30 = $[66];
    }
    if ($[67] !== t29 || $[68] !== t30) {
      t12 = <div className="tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4 tw-pb-3"><div className="tw-flex tw-items-center tw-justify-between tw-gap-4">{t29}{t30}</div></div>;
      $[67] = t29;
      $[68] = t30;
      $[69] = t12;
    } else {
      t12 = $[69];
    }
    const t31 = artworkMedia?.mime_type;
    let t32;
    if ($[70] !== t31 || $[71] !== winner.drop.id) {
      t32 = <MediaTypeBadge mimeType={t31} dropId={winner.drop.id} size="sm" />;
      $[70] = t31;
      $[71] = winner.drop.id;
      $[72] = t32;
    } else {
      t32 = $[72];
    }
    let t33;
    if ($[73] !== title) {
      t33 = <h3 className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-100">{title}</h3>;
      $[73] = title;
      $[74] = t33;
    } else {
      t33 = $[74];
    }
    let t34;
    if ($[75] !== t32 || $[76] !== t33) {
      t34 = <div className="tw-flex tw-items-center tw-gap-x-2">{t32}{t33}</div>;
      $[75] = t32;
      $[76] = t33;
      $[77] = t34;
    } else {
      t34 = $[77];
    }
    let t35;
    if ($[78] !== description) {
      t35 = <p className="tw-mb-0 tw-line-clamp-2 tw-text-sm tw-text-iron-400">{description}</p>;
      $[78] = description;
      $[79] = t35;
    } else {
      t35 = $[79];
    }
    if ($[80] !== t34 || $[81] !== t35) {
      t13 = <div className="tw-px-4 tw-pb-4 tw-pt-4"><div className="tw-space-y-1">{t34}{t35}</div></div>;
      $[80] = t34;
      $[81] = t35;
      $[82] = t13;
    } else {
      t13 = $[82];
    }
    if ($[83] !== winner.drop) {
      t14 = <WaveWinnerIdentity drop={winner.drop} variant="full" cardVariant="chat" className="tw-px-4 tw-pb-4" />;
      $[83] = winner.drop;
      $[84] = t14;
    } else {
      t14 = $[84];
    }
    if ($[85] !== artworkMedia) {
      t15 = artworkMedia && <div className="tw-flex tw-h-96 tw-justify-center tw-bg-iron-950"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
      $[85] = artworkMedia;
      $[86] = t15;
    } else {
      t15 = $[86];
    }
    t8 = "tw-mt-4 tw-space-y-4 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4";
    if ($[87] !== winner.drop) {
      t9 = <MemeDropTraits drop={winner.drop} />;
      $[87] = winner.drop;
      $[88] = t9;
    } else {
      t9 = $[88];
    }
    t6 = "tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2 tw-pt-1";
    const t36 = `tw-font-medium ${totalVoteClass}`;
    let t37;
    if ($[89] !== rating) {
      t37 = formatNumberWithCommas(rating);
      $[89] = rating;
      $[90] = t37;
    } else {
      t37 = $[90];
    }
    let t38;
    if ($[91] !== t36 || $[92] !== t37) {
      t38 = <span className={t36}>{t37}</span>;
      $[91] = t36;
      $[92] = t37;
      $[93] = t38;
    } else {
      t38 = $[93];
    }
    let t39;
    if ($[94] !== creditType) {
      t39 = <span className="tw-font-normal tw-text-iron-400">{creditType} {WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
      $[94] = creditType;
      $[95] = t39;
    } else {
      t39 = $[95];
    }
    if ($[96] !== t38 || $[97] !== t39) {
      t7 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm tw-leading-5">{t38}{t39}</div>;
      $[96] = t38;
      $[97] = t39;
      $[98] = t7;
    } else {
      t7 = $[98];
    }
    t5 = "tw-flex tw-items-center tw-gap-2 tw-text-sm tw-leading-5";
    t3 = "tw-flex tw-items-center -tw-space-x-2";
    t4 = topVoters.map(_temp6);
    $[4] = artworkMedia;
    $[5] = description;
    $[6] = hasTouchScreen;
    $[7] = onDropClick;
    $[8] = rating;
    $[9] = title;
    $[10] = touchHandlers;
    $[11] = wave.voting.credit_type;
    $[12] = winner;
    $[13] = creditType;
    $[14] = extendedDrop;
    $[15] = hasUserVoted;
    $[16] = isUserVoteNegative;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
    $[25] = t18;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = userVote;
    $[34] = userVoteClass;
  } else {
    creditType = $[13];
    extendedDrop = $[14];
    hasUserVoted = $[15];
    isUserVoteNegative = $[16];
    t10 = $[17];
    t11 = $[18];
    t12 = $[19];
    t13 = $[20];
    t14 = $[21];
    t15 = $[22];
    t16 = $[23];
    t17 = $[24];
    t18 = $[25];
    t3 = $[26];
    t4 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
    t8 = $[31];
    t9 = $[32];
    userVote = $[33];
    userVoteClass = $[34];
  }
  let t19;
  if ($[99] !== t3 || $[100] !== t4) {
    t19 = <div className={t3}>{t4}</div>;
    $[99] = t3;
    $[100] = t4;
    $[101] = t19;
  } else {
    t19 = $[101];
  }
  let t20;
  if ($[102] !== ratersCount) {
    t20 = formatNumberWithCommas(ratersCount);
    $[102] = ratersCount;
    $[103] = t20;
  } else {
    t20 = $[103];
  }
  const t21 = ratersCount === 1 ? "voter" : "voters";
  let t22;
  if ($[104] !== t21) {
    t22 = <span className="tw-font-normal tw-text-iron-400">{t21}</span>;
    $[104] = t21;
    $[105] = t22;
  } else {
    t22 = $[105];
  }
  let t23;
  if ($[106] !== t20 || $[107] !== t22) {
    t23 = <span className="tw-font-medium tw-text-iron-50">{t20}{" "}{t22}</span>;
    $[106] = t20;
    $[107] = t22;
    $[108] = t23;
  } else {
    t23 = $[108];
  }
  let t24;
  if ($[109] !== t19 || $[110] !== t23 || $[111] !== t5) {
    t24 = <div className={t5}>{t19}{t23}</div>;
    $[109] = t19;
    $[110] = t23;
    $[111] = t5;
    $[112] = t24;
  } else {
    t24 = $[112];
  }
  let t25;
  if ($[113] !== creditType || $[114] !== hasUserVoted || $[115] !== isUserVoteNegative || $[116] !== userVote || $[117] !== userVoteClass) {
    t25 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-leading-5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:</span><span className={`tw-font-medium ${userVoteClass}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-font-normal tw-text-iron-400">{creditType}</span></span></div></div>;
    $[113] = creditType;
    $[114] = hasUserVoted;
    $[115] = isUserVoteNegative;
    $[116] = userVote;
    $[117] = userVoteClass;
    $[118] = t25;
  } else {
    t25 = $[118];
  }
  let t26;
  if ($[119] !== t24 || $[120] !== t25 || $[121] !== t6 || $[122] !== t7) {
    t26 = <div className={t6}>{t7}{t24}{t25}</div>;
    $[119] = t24;
    $[120] = t25;
    $[121] = t6;
    $[122] = t7;
    $[123] = t26;
  } else {
    t26 = $[123];
  }
  let t27;
  if ($[124] !== t26 || $[125] !== t8 || $[126] !== t9) {
    t27 = <div className={t8}>{t9}{t26}</div>;
    $[124] = t26;
    $[125] = t8;
    $[126] = t9;
    $[127] = t27;
  } else {
    t27 = $[127];
  }
  let t28;
  if ($[128] !== extendedDrop || $[129] !== hasTouchScreen || $[130] !== isActive || $[131] !== setIsActive) {
    t28 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={extendedDrop} onOpenChange={() => setIsActive(false)} /></div></CommonDropdownItemsMobileWrapper>, document.body);
    $[128] = extendedDrop;
    $[129] = hasTouchScreen;
    $[130] = isActive;
    $[131] = setIsActive;
    $[132] = t28;
  } else {
    t28 = $[132];
  }
  let t29;
  if ($[133] !== t10 || $[134] !== t11 || $[135] !== t12 || $[136] !== t13 || $[137] !== t14 || $[138] !== t15 || $[139] !== t27 || $[140] !== t28) {
    t29 = <div className={t10} {...t11}>{t12}{t13}{t14}{t15}{t27}{t28}</div>;
    $[133] = t10;
    $[134] = t11;
    $[135] = t12;
    $[136] = t13;
    $[137] = t14;
    $[138] = t15;
    $[139] = t27;
    $[140] = t28;
    $[141] = t29;
  } else {
    t29 = $[141];
  }
  let t30;
  if ($[142] !== t16 || $[143] !== t29) {
    t30 = <div className={t16}>{t29}</div>;
    $[142] = t16;
    $[143] = t29;
    $[144] = t30;
  } else {
    t30 = $[144];
  }
  let t31;
  if ($[145] !== t17 || $[146] !== t18 || $[147] !== t30) {
    t31 = <div onClick={t17} className={t18}>{t30}</div>;
    $[145] = t17;
    $[146] = t18;
    $[147] = t30;
    $[148] = t31;
  } else {
    t31 = $[148];
  }
  return t31;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(e_0) {
  return e_0.stopPropagation();
}
function _temp5(e_1) {
  return e_1.stopPropagation();
}
function _temp6(voter) {
  return <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle ?? voter.profile.id}`} onClick={_temp5} scroll={false} className="tw-transition-transform desktop-hover:hover:tw-translate-y-[-2px]" data-tooltip-id={`voter-${voter.profile.handle ?? voter.profile.primary_address}-${voter.rating}`}>{voter.profile.pfp ? <Image className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={getScaledImageUri(voter.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${voter.profile.handle ?? voter.profile.id}'s profile picture`} width={24} height={24} /> : <div className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link><Tooltip id={`voter-${voter.profile.handle ?? voter.profile.primary_address}-${voter.rating}`} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES}>{voter.profile.handle} -{" "}{formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>;
}